import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';

import { User } from '../models/user.model'
import { Question } from '../models/question.model';
import { AuthenticationService } from './authentication.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { $ } from 'protractor';
import { Response } from 'selenium-webdriver/http';
import { UserStates } from '../models/userstate.model';
import { UserManagement } from '../models/management.model';
import { UserRoles } from '../models/roles.model';

@Injectable({ providedIn: 'root' })
export class UserService {

  Url: string;

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string,
    private authenticationService: AuthenticationService) {
    this.Url = baseUrl; 
  }

  getAll() {
    return this.http.get<User[]>(this.Url + 'api/users/GetAll')
    .map((res: User[]) => res);
  }
  
  getRoles() {
    return this.http.get<UserRoles[]>(this.Url + 'api/roles');
  }

  getById(IdUser: string) {
    let params = new HttpParams().set("IdUser", IdUser);
    return this.http.get<any>(this.Url + '/api/users/GetById', { params: params });
  }

  setFirstTime(Question: Question, password: string, answer: string) {
    this.authenticationService.currentUserValue.userPassword = password;
    this.authenticationService.currentUserValue.answer = answer;
    this.authenticationService.currentUserValue.idQuestion = Question.idQuestion;
    this.authenticationService.currentUserValue.temporalPassword = false;
    return this.http.patch<User>(this.Url + 'api/users/firstTime',this.authenticationService.currentUserValue);
  }

  setNewPassword(newPassword: string, user: User = this.authenticationService.currentUserValue, temporal: boolean = false) {
    user.userPassword = newPassword;
    user.temporalPassword = temporal;
    return this.http.patch<User>(this.Url + 'api/users/password', user);
  }

  addUser(newUser: User) {
    return this.http.post(this.Url + 'api/users/Create', newUser)      
  }

  setStateUser(idState: number, motivo: string, user: User = this.authenticationService.currentUserValue) {
    user.fkUserState = idState;
    user.stateObservation = motivo;
    return this.http.post(this.Url + 'api/users/state', user);
  }

  updateUser(user: User = this.authenticationService.currentUserValue) {
    return this.http.patch(this.Url + 'api/users/Update', user);
  }

  getUserManagement() {
    return this.http.get<UserManagement[]>(this.Url + 'api/users/getUserManagement')
  }

  setRandomPassword(userid: number) {
    let user = new User();
    user.idUser = userid;
    return this.http.patch<User>(this.Url + 'api/users/randomPass', user);
  }
}
